import './App.css';
import SetupRouters from './routers';
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  return (
    <div className="App">
      <SetupRouters />
    </div>
  );
}

export default App;
